/** Same paired orders only: partial buyer-price coverage must not be compared
 * with seller revenue from all orders. Used for a day and aggregate operands. */
export function orderCoinvest(customer: number | null, count: number | null, cabinet: number | null): number | null {
  return customer != null && count != null && cabinet != null && Number.isFinite(customer) && Number.isFinite(count) && Number.isFinite(cabinet) && count > 0 && cabinet > 0
    ? Math.max(0, (cabinet - customer) / cabinet) * 100 : null;
}

type CustomerSeries = { customerPriceSum?: number[]; customerPriceCount?: number[]; cabinetForCustomer?: number[] };

/** Period ratios use the original sums, never a mean of daily percentages or
 * rounded daily checks. Unknown customer prices do not acquire fake weights. */
export function storePeriodCustomerMetrics(series: CustomerSeries, from: number, to: number) {
  const sum = (values: number[]) => values.slice(from, to).reduce((total, value) => total + (Number.isFinite(value) ? value : 0), 0);
  if (!series.customerPriceSum || !series.customerPriceCount) return { check: null, coinvest: null };
  const customer = sum(series.customerPriceSum);
  const count = sum(series.customerPriceCount);
  const cabinet = series.cabinetForCustomer ? sum(series.cabinetForCustomer) : 0;
  return {
    check: count > 0 ? customer / count : null,
    coinvest: orderCoinvest(customer, count, cabinet),
  };
}
